import React from 'react';
import SimpleCrud from '../components/SimpleCrud';

export default function AutofillableFields() {
  return <SimpleCrud title="Autofillable Fields" basePath="autofillableFields" fields={[
    { key: 'name', label: 'Slot name (e.g. First Name)' },
    { key: 'type', label: 'Type (text|date|select)' },
    { key: 'description', label: 'Description' },
  ]} />;
}
